export function canAccess(roles = ['admin', 'employee', 'externalEmployee']) {
  const currentRole = localStorage.getItem("auth.role");

  return roles.includes(currentRole);
}